import React from 'react';
import styles from './CircularProgress.module.css';

class CircularProgress extends React.Component {
  constructor(props) {
    super(props);
    
    const { radius, stroke } = this.props;
    
    this.normalizedRadius = radius - stroke * 2;
    this.circumference = this.normalizedRadius * 2 * Math.PI;
  }
  
  render() {
    const { radius, stroke, progress } = this.props;
    const strokeDashoffset = this.circumference - progress / 100 * this.circumference;
  
    return (
      <svg
        height={radius * 2}
        width={radius * 2}
       >
        <circle
          stroke="#f3f3f3"
          fill="transparent"
          strokeWidth={ stroke }
          r={ this.normalizedRadius }
          cx={ radius }
          cy={ radius }
         />
        <circle
          stroke="#3655F2"
          fill="transparent"
          strokeWidth={ stroke }
          strokeDasharray={ this.circumference + ' ' + this.circumference }
          style={ { strokeDashoffset } }
          r={ this.normalizedRadius }
          cx={ radius }
          cy={ radius }
          className={styles.indicator}
         />
      </svg>
    );
  }
}

export default CircularProgress;